module.exports = __webpack_public_path__ + "img/image3.bf417650.jpeg";